var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-list--toggle" },
    [
      _c(
        "UIInputToggle",
        {
          attrs: {
            id: _vm.filter.key,
            value: _vm.filter.label,
            checked: !!_vm.filter.active
          },
          on: {
            input: function(val) {
              return _vm.toggleFilter(
                val,
                _vm.filter.key,
                _vm.filter.value,
                _vm.filter.label
              )
            }
          }
        },
        [_c("span", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.filter.label))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }